import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import OptionalOption from "../../components/FilterComponents/OptionalOption";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import { handleDropdownClose } from "../../utils/utils";

const ConverstionRateFilterData = ({ isSidebarOpen, filterData, onSetFilterData, from }) => {
    const [config] = useAuth();
    const [loading, setLoading] = useState(false);
    const [contactData, setContactData] = useState([]);
    const [bdsOptions, setBdsOptions] = useState([])
    const selectRef = useRef(null);
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleFilterChange = (value, name) => {
        onSetFilterData({ ...filterData, [name]: value });
    };

    const fetchSuggestions = (inputValue) => {
        axios
            .get(`${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}`, config)
            .then((res) => {
                const data = res.data.data.contact_list;
                const options = data.map((contact) => ({ value: contact.id, label: `${contact.first_name} ${contact.last_name}` }));
                setContactData(options);
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            });
    };

    const fetchUsers = () => {
        setLoading(true)
        axios
            .get(`${BASE_URL}/get-datalisting?list=users`, config)
            .then((res) => {
                const data = res?.data?.data
                const options = data?.map((el) => ({
                    value: el?.id,
                    label: `${el?.first_name} ${el?.last_name}`,
                    role: el?.role_id,
                }))
                setBdsOptions(options)
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message)
                }
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (isSidebarOpen) {
            fetchUsers();
        }
    }, [isSidebarOpen]);

    useEffect(() => {
        const handleClose = () => {
            setIsOpen(false);
        };
        handleDropdownClose(dropdownRef, handleClose);
    }, []);

    


    return (
        <div>

            <div className="mt-4">
                <label className="dark-H head-4 mb-2">User</label>
                <Select
                    className="body-S"
                    placeholder="Search here..."
                    value={bdsOptions?.find((el) => el?.value == filterData?.bds) || null}
                    options={bdsOptions}
                    onChange={(option) => {
                        handleFilterChange(option?.value, "bds");
                    }}
                />
            </div>


            <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

            <div>
                <p className="head-4 dark-H capitalize">Timeframe</p>

                <OptionalOption
                    activeTab="date"
                    onSetLastDate={(value) => handleFilterChange(value, "created_at")}
                    date={filterData?.created_at}
                    onSetDateRange1={(value) => {
                        handleFilterChange(value, "created_start_date");
                    }}
                    date2={filterData?.created_start_date}
                    onSetDateRange2={(value) => handleFilterChange(value, "created_end_date")}
                    date3={filterData?.created_end_date}
                    onClear={() => {
                        onSetFilterData({ ...filterData, created_at: "", created_start_date: "", created_end_date: "" });
                    }}
                />
            </div>


        </div>
    );
};

export default ConverstionRateFilterData;
